import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=37edb85d&scoped=true&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.vue?vue&type=style&index=0&id=37edb85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edb85d",
  null
  
)

export default component.exports